import React, { useState } from 'react';
import {
    CardExpiryElement,
    CardNumberElement,
    CardCvcElement,
    useStripe,
    useElements
} from '@stripe/react-stripe-js';
import { Grid, Button } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import { useNotify } from '../../hooks/useNotify';
import { AmexIcon, DiscoverIcon, MastercardIcon, VisaIcon } from '../../icons';

const PaymentCardForm = ({ customer, setToken, theme }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [cardHolderName, changeCardHolderName] = useState('');
    const [brand, setBrand] = useState('');
    const { notifyError } = useNotify();
    const [complete, setComplete] = useState({ number: false, cvc: false, expiration: false });

    const submitAction = ev => {
        ev.preventDefault();
        const cardElement = elements.getElement(CardNumberElement);
        stripe
            .createToken(cardElement, {
                name: cardHolderName
            })
            .then(result => {
                console.log(result);
                if (result.error) {
                    notifyError(result.error.message || result.error.body.message);
                    return;
                }
                if (result.token) {
                    setToken({
                        stripe_last4: result.token.card.last4,
                        stripe: result.token
                    });
                    return;
                }
                notifyError(`Unknown error: ${JSON.stringify(result)}`);
            });
        return false;
    };

    return customer && customer.stripe_last4 ? (
        <Grid container item xs={12} alignItems="center">
            <Grid item xs={6} className="mb-2">
                <h3>Credit Card Information</h3>
            </Grid>
            <Grid item xs={6} className="mb-2">
                <h2 className="text-right"> **** **** **** {customer.stripe_last4} </h2>
            </Grid>
            <Grid item xs={12} className="text-right">
                <Button
                    variant="contained"
                    onClick={() => {
                        setToken({ stripe_last4: null, stripe: null });
                        setComplete({ number: false, cvc: false, expiration: false });
                        setBrand('');
                    }}
                >
                    Change credit card
                </Button>
            </Grid>
        </Grid>
    ) : (
        <Grid
            component="form"
            className="stripe-form"
            container
            item
            alignItems="center"
            xs={12}
            onSubmit={submitAction}
        >
            <Grid item xs={12} className="mb-2">
                <h3>Credit Card Information</h3>
            </Grid>

            <Grid item container xs={12} className="mb-2" spacing={2}>
                <Grid item xs={12}>
                    <span className="label">CREDIT CARD NUMBER</span>
                </Grid>
                <Grid item container alignItems="center" style={{ paddingTop: 0 }} spacing={2}>
                    <Grid item xs={12} md={6}>
                        <CardNumberElement
                            onChange={card => {
                                setComplete({ ...complete, number: card.complete });
                                setBrand(card.brand);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} container className="card-icons" spacing={2}>
                        <Grid item>
                            <VisaIcon
                                color={brand === 'visa' ? theme.palette.primary.main : 'disabled'}
                            />
                        </Grid>
                        <Grid item>
                            <MastercardIcon
                                color={
                                    brand === 'mastercard' ? theme.palette.primary.main : 'disabled'
                                }
                            />
                        </Grid>
                        <Grid item>
                            <AmexIcon
                                color={brand === 'amex' ? theme.palette.primary.main : 'disabled'}
                            />
                        </Grid>
                        <Grid item>
                            <DiscoverIcon
                                color={
                                    brand === 'discover' ? theme.palette.primary.main : 'disabled'
                                }
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item container xs={12} md={6} direction="column">
                    <span className="label mb-2">CARD HOLDER NAME</span>
                    <div className="StripeElement">
                        <input
                            placeholder="CARD HOLDER NAME"
                            value={cardHolderName || ''}
                            onChange={ev => changeCardHolderName(ev.target.value)}
                            required
                        />
                    </div>
                </Grid>
            </Grid>
            <Grid item container xs={12} className="mb-2" spacing={2}>
                <Grid item container xs={12} md={3} direction="column">
                    <span className=" label mb-2">EXPIRATION</span>
                    <CardExpiryElement
                        onChange={event => {
                            setComplete({ ...complete, expiration: event.complete });
                        }}
                    />
                </Grid>
                <Grid item container xs={12} md={3} direction="column">
                    <span className="label mb-2">CVC</span>
                    <CardCvcElement
                        onChange={event => {
                            setComplete({ ...complete, cvc: event.complete });
                        }}
                    />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Button
                    variant="contained"
                    className="btn-squared"
                    disabled={
                        !cardHolderName || !complete.number || !complete.cvc || !complete.expiration
                    }
                    onClick={submitAction}
                    type="button"
                >
                    Verify and add card
                </Button>
            </Grid>
        </Grid>
    );
};

export default withTheme(PaymentCardForm);
